import { Router } from 'next/router';
import { createRef } from 'react';
import { memo, useLayoutEffect, useRef, useState, useEffect } from 'react';

const isBrowser = typeof window !== 'undefined';

const isClient = createRef();

// const LazyHydration = ({ as: As = 'div', Component, ...rest }) => {
//   const ref = useRef();
//   const [render, setRender] = useState(isClient.current);

//   const useFn = isBrowser ? useLayoutEffect : useEffect;

//   useFn(() => {
//     isClient.current = true; // client side

//     if (ref.current) {
//       const set = () => setRender(true);
//       Router.events.on('routeChangeStart', set);
//       ref.current.addEventListener('mouseenter', set);
//       return () => {
//         ref?.current?.removeEventListener('mouseenter', set);
//         Router.events.off('routeChangeStart', set);
//       };
//     }
//   }, []);

//   if (!isBrowser || render) {
//     return <Component {...rest} />;
//   } else {
//     return (
//       <As
//         ref={ref}
//         dangerouslySetInnerHTML={{ __html: '', }}
//         suppressHydrationWarning
//       />
//     );
//   }
// };

const LazyHydration = ({ Component, ...rest }) => <Component {...rest} />;

export default LazyHydration;
